export default __webpack_public_path__ + "static/media/whatsapp.6b2242a8.svg";